<template>
  <section id="toxicology-add-test-block" v-loading="loading">
    <ul class="add-tests-selection">
      <li
        class="each-test"
        v-for="(category, index) of getFilteredCategories(
          'CLINICAL_CHEMISTRY',
          ['INHALENAT_ALLERGENS-36', 'FOOD_ALLERGENS-25'],
          'exclude'
        )"
        :key="index"
      >
        <el-collapse v-model="activeNameCollapse" accordion>
          <el-collapse-item :name="index" class="screening">
            <template #title>
              <el-checkbox
                class="test-category"
                :model-value="
                  isCheckAll(category.case_type_code, category.panel_id)
                "
                @change="
                  checkAll($event, category.case_type_code, category.panel_id)
                "
                :disabled="
                  category.panel_code === 'ALL_TESTS' ||
                  category.panel_code === 'SEND_OUTS'
                "
              ></el-checkbox>
              {{ category.panel_title }}
            </template>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: baseline;
              "
            >
              <el-checkbox
                class="test-category"
                :model-value="
                  isCheckAll(category.case_type_code, category.panel_id)
                "
                @change="
                  checkAll($event, category.case_type_code, category.panel_id)
                "
                :disabled="
                  category.panel_code === 'ALL_TESTS' ||
                  category.panel_code === 'SEND_OUTS'
                "
                >All</el-checkbox
              >
            </div>
            <el-checkbox-group v-model="selectedCategoriesWithTests">
              <div
                v-for="(item, index) of getCategoryWiseTestsData(
                  category.case_type_code,
                  category.panel_id
                )"
                :key="index"
              >
                <div class="each-check-box">
                  <el-checkbox
                    :disabled="
                      !(
                        category.panel_code === 'ALL_TESTS' ||
                        category.panel_code === 'SEND_OUTS' ||
                        category.panel_code === 'OTHER_TESTS'
                      )
                    "
                    :label="item.label_value"
                    @change="
                      checkSingleTest(
                        $event,
                        category.case_type_code,
                        category.panel_id,
                        item._id
                      )
                    "
                  >
                    {{ item.test_name }}
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </li>
    </ul>

    <el-tabs v-model="activeToxicologyTab" class="blood-inner-tab">
      <el-tab-pane name="Allergy Test Panel">
        <template #label>
          <el-checkbox
            class="position-relative-top-3"
            :model-value="
              isMultiCheckAll('CLINICAL_CHEMISTRY', [
                'INHALENAT_ALLERGENS-36',
                'FOOD_ALLERGENS-25',
              ])
            "
            @change="
              multiCheckAll($event, 'CLINICAL_CHEMISTRY', [
                'INHALENAT_ALLERGENS-36',
                'FOOD_ALLERGENS-25',
              ])
            "
          ></el-checkbox>
          <span class="ml-10">Allergy test panel</span>
        </template>

        <ul class="add-tests-selection">
          <li
            class="each-test"
            v-for="(category, index) of getFilteredCategories(
              'CLINICAL_CHEMISTRY',
              ['INHALENAT_ALLERGENS-36', 'FOOD_ALLERGENS-25'],
              'include'
            )"
            :key="index"
          >
            <el-collapse accordion>
              <el-collapse-item :name="index">
                <template #title>
                  <el-checkbox
                    class="test-category"
                    :model-value="
                      isCheckAll(category.case_type_code, category.panel_id)
                    "
                    @change="
                      checkAll(
                        $event,
                        category.case_type_code,
                        category.panel_id
                      )
                    "
                  >
                  </el-checkbox>
                  {{ category.panel_title }}</template
                >
                <el-checkbox
                  class="test-category"
                  :model-value="
                    isCheckAll(category.case_type_code, category.panel_id)
                  "
                  @change="
                    checkAll($event, category.case_type_code, category.panel_id)
                  "
                  >All
                </el-checkbox>

                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div
                    v-for="(item, index) of getCategoryWiseTestsData(
                      category.case_type_code,
                      category.panel_id
                    )"
                    :key="index"
                  >
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" disabled>{{
                        item.test_name
                      }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </section>
  <div class="default-modal heightAujust wellness">
    <el-dialog v-model="cortisolDialog" top="10%" width="20%">
      <div class="dialog-header">
        <span class="header-part"> Select Any One test </span>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="cortisolDialog = false"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div class="popup-date">
        <el-checkbox-group v-model="selectedTests">
          <el-checkbox 
          v-for="(test, index) in cortisolTests"
          :key="index"
          :label="test"
          :disabled="selectedTests.length > 0 && !selectedTests.includes(test)" >
          {{ test.test_name }}
         </el-checkbox>
       </el-checkbox-group>
      </div>
       <div class="dialog-footer">
        <el-button class="cancel-button" @click="cortisolDialog = false">CANCEL</el-button>
        <el-button class="blue-save-button" @click="onConfirmm" :disabled="selectedTests.length == 0">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "BloodPanelTestSelection",
  props: ["panelTestsData", "searchString"],
  mixins: [AppHelper, UserPermissionsHelper],
  data() {
    return {
      activeNameCollapse: "",
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      activeToxicologyTab: "Allergy Test Panel",
      activeNameCollapseScreening: [0, 1],
      userType: "",
      loading: false,
      selectedCategories: [],
      cortisolDialog: false,
      cortisolTests: [],
      selectedTests: [],
    };
  },
  mounted() {
    // Added well ness panels
    this.panelsTestsData = this.panelTestsData;
    this.panelsTestsData.selectedCategories.forEach((category) => {
      category.test_ids.forEach((test) => {
        this.selectedCategoriesWithTests.push(`${category.panel_id}:${test}`);
      });
    });
  },
  computed: {
    ...mapGetters("labTests", [
      "getNewLabGroupPanelTests",
    ]),
    selectedCategoriesWithTests() {
      if (!this.panelsTestsData?.selectedCategories) return [];

      return this.panelsTestsData.selectedCategories.flatMap((category) => {
        return category.test_ids.map((test) => `${category.panel_id}:${test}`);
      });
    },
  },
  methods: {
    getFilteredCategories(caseType, categories, includeType) {
      let data = [];

      if (includeType == "include") {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            categories.includes(el.panel_code)
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            !categories.includes(el.panel_code)
        );
      }

      data = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return data;
    },

    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_id === category &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) => el.case_type_code === caseType && el.panel_id === category
        );
      }

      data = data.map((e) => {
        e.label_value = e.panel_id + ":" + e._id;
        return e;
      });

      return this.sortByKey(data, "test_name");
    },
    checkAll(data, caseType, panelId) {
      let panelCode = this.getNewLabGroupPanelTests.filter((e) => e.panel_id == panelId).map((e) => e.panel_code)[0]
      let quarterlyTestcodes = [
        "CBC_W_AUTOMATED_DIFF",
        "VITAMIN_D",
        "VITAMIN_B12",
        "DHEA_S",
        "ESTRADIOL",
        "FOLATE",
        "FREE_T3",
        "HGBA1C",
        "INSULIN",
        "IRON_PROFILE",
        "MAGNESIUM",
        "SHBG",
        "URIC_ACID",
        "GGT",
        "LDH",
        "TESTOSTERONE",
        "PROGESTERONE"
      ]
      let semiTestcodes = ["CBC_W_AUTOMATED_DIFF",
        "VITAMIN_D",
        "VITAMIN_B12",
        "FERRITIN",
        "DHEA_S",
        "ESTRADIOL",
        "FOLATE",
        "FREE_T3",
        "FREE_T4",
        "HGBA1C",
        "INSULIN",
        "IRON_PROFILE",
        "MAGNESIUM",
        "SHBG",
        "TSH",
        "URIC_ACID",
        "GGT",
        "LDH",
        "TESTOSTERONE",
        "PROGESTERONE"
      ]
      let testCodes = (panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_FEMALE" || panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_MALE") ? semiTestcodes : quarterlyTestcodes
      if (panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_MALE" || panelCode === "QUARTERLY_ANNUAL_WELLNESS_PANEL_MALE") {
        testCodes = testCodes.filter(code => code != "PROGESTERONE");
      }
      if (panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_FEMALE" || panelCode === "QUARTERLY_ANNUAL_WELLNESS_PANEL_FEMALE") {
        testCodes = testCodes.filter(code => code != "TESTOSTERONE");
      }
      if (data && panelCode != "QUARTERLY_ANNUAL_WELLNESS_PANEL_FEMALE" && panelCode != "QUARTERLY_ANNUAL_WELLNESS_PANEL_MALE" && panelCode != "SEMI_ANNUAL_WELLNESS_PANEL_FEMALE" && panelCode != "SEMI_ANNUAL_WELLNESS_PANEL_MALE") {
        this.panelsTestsData.selectedCategories.push({
          panel_id: panelId,
          case_type_code: caseType,
          all_tests: true,
          test_ids: this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e._id),
        });
 
        this.selectedCategoriesWithTests = [
          ...this.selectedCategoriesWithTests,
          ...this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value),
        ];
      } else if (data && (panelCode === "QUARTERLY_ANNUAL_WELLNESS_PANEL_FEMALE" || panelCode === "QUARTERLY_ANNUAL_WELLNESS_PANEL_MALE" || panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_FEMALE" || panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_MALE")) {
        const targetPanels = (panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_FEMALE" || panelCode === "SEMI_ANNUAL_WELLNESS_PANEL_MALE") ? ["COMP_METABOLIC_PANEL", "LIPID_PANEL"] : ["COMP_METABOLIC_PANEL"];
        let mappedPanels = this.getNewLabGroupPanelTests.filter((e) => targetPanels.includes(e.panel_code))
        let mappedTests = this.getNewLabGroupPanelTests.filter((e) => testCodes.includes(e.test_code) && e.panel_code === "ALL_TESTS")
        let allMappedTests = [...mappedPanels, ...mappedTests]
        let uniquePanelIds = [...new Set(allMappedTests.map((e) => e.panel_id))]
 
        uniquePanelIds.forEach((selectedId) => {
          const testsForPanel = allMappedTests.filter((test) => test.panel_id == selectedId);
          const isVirtualPanel = testsForPanel.some(test =>
            ["ALL_TESTS", "SEND_OUTS"].includes(test.panel_code)
          );
 
          if (isVirtualPanel) {
            // Check if this virtual panel_id already exists
            const existingPanelIndex = this.panelsTestsData.selectedCategories.findIndex(
              (item) => item.panel_id === selectedId
            );
 
            const testIdsToAdd = testsForPanel.map((test) => test._id);
            const labelValuesToAdd = testsForPanel.map((test) => test.label_value);
 
            if (existingPanelIndex !== -1) {
              // Panel already exists, merge new test_ids (avoid duplicates)
              const existing = this.panelsTestsData.selectedCategories[existingPanelIndex];
              existing.test_ids = Array.from(new Set([...existing.test_ids, ...testIdsToAdd]));
 
              this.selectedCategoriesWithTests = Array.from(new Set([
                ...this.selectedCategoriesWithTests,
                ...labelValuesToAdd,
              ]));
            } else {
              // New virtual panel entry
              this.panelsTestsData.selectedCategories.push({
                panel_id: selectedId,
                case_type_code: caseType,
                all_tests: true,
                test_ids: testIdsToAdd,
              });
 
              this.selectedCategoriesWithTests = [
                ...this.selectedCategoriesWithTests,
                ...labelValuesToAdd,
              ];
            }
          } else {
            // Normal panel check by panel_id
            const alreadyExists = this.panelsTestsData.selectedCategories.some(
              (item) => item.panel_id === selectedId
            );
 
            if (!alreadyExists) {
              this.panelsTestsData.selectedCategories.push({
                panel_id: selectedId,
                case_type_code: caseType,
                all_tests: true,
                test_ids: testsForPanel.map((test) => test._id),
              });
 
              this.selectedCategoriesWithTests = [
                ...this.selectedCategoriesWithTests,
                ...testsForPanel.map((test) => test.label_value),
              ];
            }
          }
        });
        this.cortisolDialog = true
        const cortisolTestCodes = ["CORTISOL_PM", "CORTISOL_AM"]
        this.cortisolTests = this.getNewLabGroupPanelTests.filter((e) => cortisolTestCodes.includes(e.test_code))
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == panelId && e.case_type_code == caseType
        );
        if (index > -1) {
          let panelId = this.panelsTestsData.selectedCategories[index].panel_id;
          let testIds = this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value);
          this.selectedCategoriesWithTests =
            this.selectedCategoriesWithTests.filter(
              (e) => !testIds.includes(e)
            );
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
      }
    },
    onConfirmm() {
      const selectedTest = this.selectedTests[0];
      if (!selectedTest) return;
      const matchedPanel = this.panelsTestsData.selectedCategories.find(
        (e) => e.panel_id === selectedTest.panel_id 
      );
      if (matchedPanel) {
        if (!matchedPanel.test_ids.includes(selectedTest._id)) {
          matchedPanel.test_ids.push(selectedTest._id);
        }
        // console.log("Updated matchedPanel:", this.panelsTestsData.selectedCategories);
      } else {
        console.warn("No panel matched for panel_id:", selectedTest.panel_id);
      }
      this.selectedTests = []
      this.cortisolDialog = false
    },
    isCheckAll(caseType, category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (selectedCategory) =>
          selectedCategory.case_type_code == caseType &&
          selectedCategory.panel_id == category
      );
      let selectedCategoryFromPanel = this.getNewLabGroupPanelTests.find(
        (e) => e.panel_id == category
      );
      if (
        selectedCategory &&
        selectedCategoryFromPanel &&
        selectedCategoryFromPanel.is_mandatory
      ) {
        return true;
      }
      return false;
    },
    checkSingleTest(data, caseType, category, testId) {
      if (data) {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            this.panelsTestsData.selectedCategories[index].test_ids.push(
              testId
            );
          } else {
            this.panelsTestsData.selectedCategories[index].test_ids = [testId];
          }
        } else {
          this.panelsTestsData.selectedCategories.push({
            panel_id: category,
            case_type_code: caseType,
            all_tests: false,
            test_ids: [testId],
          });
        }
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            let testIndex = this.panelsTestsData.selectedCategories[
              index
            ].test_ids.findIndex((e) => e == testId);
            if (testIndex > -1) {
              this.panelsTestsData.selectedCategories[index].test_ids.splice(
                testIndex,
                1
              );
            }

            if (
              this.panelsTestsData.selectedCategories[index].test_ids.length ==
              0
            ) {
              this.panelsTestsData.selectedCategories.splice(index, 1);
            }
          }
        }
      }
    },
    multiCheckAll(data, caseType, categories) {
      let categoryPanelsIds = this.getCategoriesWiseTestsData(
        caseType,
        categories,
        true
      ).map((e) => e.panel_id);

      categoryPanelsIds = Array.from(new Set(categoryPanelsIds));
      categoryPanelsIds.forEach((panelId) => {
        this.checkAll(data, caseType, panelId);
      });
    },
    getCategoriesWiseTestsData(caseType, categories, include = true) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1)) &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1))
        );
      }

      return this.sortByKey(data, "test_name");
    },
    isMultiCheckAll(caseType, categories, include = true) {
      let categoryPanelIds = this.getFilteredCategories(
        caseType,
        categories,
        "include"
      ).map((e) => e.panel_id);
      categoryPanelIds = Array.from(new Set(categoryPanelIds));
      return categoryPanelIds.every((panelId) =>
        this.panelsTestsData.selectedCategories.find(
          (category) => category.panel_id == panelId
        )
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.add-tests-view {
  padding: 0;

  .inner-navbar {
    padding: 15px 25px;
    background: rgba(223, 224, 224, 0.3);
    border-bottom: 1px solid #e0e2e2;

    .title {
      .icon-block {
        display: grid;
        grid-template-columns: 40px auto;
        align-items: center;

        img {
          width: 30px;
          margin-bottom: -5px;
        }

        h3 {
          color: #0a1b4b;
          font-weight: 500;
          font-size: 1.3em;
        }
      }
    }

    .mode-close {
      background: transparent;
      border: none;
      float: right;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .search-tests-block {
      display: flex;
      align-items: center;

      .search-input {
        max-width: 250px;
        min-width: 200px;
      }

      .selected-test {
        margin-left: 20px;

        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            &:not(:last-child) {
              margin-right: 15px;
            }

            p {
              background: #cb2955;
              border-radius: 5px;
              color: #fff;
              font-size: 0.9em;
              padding: 2px 5px;
              line-height: 20px;
              margin: 5px 0;

              &:hover {
                cursor: pointer;
              }

              img {
                width: 20px;
                margin-bottom: -5px;
                margin-left: 3px;
              }
            }
          }
        }
      }
    }
  }

  .content {
    padding: 20px 25px;
    padding-bottom: 0 !important;

    .all-tests {
      display: flex;
      flex-wrap: wrap;

      .each-test {
        width: 33.33%;

        .each-check-box {
          .el-checkbox {
            display: flex;
            align-items: flex-start;
          }

          .el-checkbox__label {
            white-space: normal;
          }

          &:not(:last-child) {
            margin-bottom: 10px !important;
          }
        }
      }
    }

    .current-tests-section {
      padding-left: 15px;
      margin-left: -15x;
      border-left: 1px solid #efefef;
      overflow-y: scroll;
      height: calc(100vh - 170px);

      &::-webkit-scrollbar,
      &::-webkit-scrollbar-thumb {
        width: 4px;
        height: 5px;
        border-radius: 5px;
        background-clip: padding-box;
        border: 3px solid #122c74;
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 0 5px;
      }

      &::-webkit-scrollbar-track {
        background-color: #ffffff;
      }

      .heading {
        margin-bottom: 20px;

        h3 {
          font-size: 1.1em;
          color: #000;
        }
      }

      .current-test-list {
        padding-right: 0.75em;

        li {
          &:not(:last-child) {
            margin-bottom: 10px;
          }

          button {
            background: #f2f4f9;
            border-radius: 20px;
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 10px;
            color: #34495e;
            font-weight: 600;

            .test-close {
              img {
                width: 15px;
              }
            }
          }
        }
      }
    }
  }

  .add-test-button-group {
    padding: 0 1.5em;
    margin: 0 -25px;
    background: rgba(236, 245, 255, 0.3);
    border-top: 1px solid #d5dae2;
    text-align: right;

    .el-button {
      font-size: 1.1em;
      margin: 15px 0px;
      padding: 0.75em 1.5em;
      background: #1dbd37;
      color: #fff;
      border: none;
    }
  }
}
</style>
<style lang="scss">
.add-tests-view {
  .el-collapse-item__header {
    line-height: 1.2;
  }

  .content {
    .all-tests {
      .each-test {
        .each-check-box {
          .el-checkbox {
            display: flex;
            align-items: flex-start;
          }

          .el-checkbox__label {
            white-space: normal;
            word-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.default-modal{
  .el-dialog{
    height: auto!important;
    @media (min-width: 1700px) {
    .add-test-popup .el-dialog {
        height: auto!important;
        width: 20%!important;
    }
}
   .dialog-header {
    background: #fff;
    border-radius: 0!important;
    display: flex;
    justify-content: space-between;
    padding: 0!important;

    .header-part {
      padding: 5px 10px;
      color: #215fad;
      align-items: center;
      display: flex;
      font-weight: 500;
    }

    button {
      background-color: #fff!important;
      border: none;
      padding: 0; 
}
}
  }
}
</style>